import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { UpdateVoiceMessageGroupCommand2 } from 'src/app/core/api/models';
import { VoiceMessagesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { SharePipesModule } from 'src/app/core/pipes/pipes.module';
import { ConsoleService } from 'src/app/core/services/console.service';
import { TranslationModule } from 'src/app/i18n';
import { PagesSharedModule } from 'src/app/pages/shared/pages-shared.module';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';
import { ShareModule } from 'src/app/shared/share.module';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';

@Component({
    selector: 'app-update-group',
    templateUrl: './update-group.component.html',
    imports: [
        CommonModule,
        ShareModule,
        TranslationModule,
        ReactiveFormsModule,
        FormsModule,
        PagesSharedModule,
        SharePipesModule,
        ModalTitleComponent,
    ]
})
export class UpdateGroupComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  model: UpdateVoiceMessageGroupCommand2 = {};
  selectedVoices: number[];
  //#endregion

  constructor(
    protected currentService: VoiceMessagesService,
    private dialogRef: MatDialogRef<UpdateGroupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.model.ids = data?.selectedVoices;
    this.model.voiceMessageGroupId = data?.groupId;
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      groupId: new FormControl('', Validators.required),
    });
  }

  //#region Api

  updateVoiceMessageGroupApi() {
    this.unSubs();
    this.loading = true;
    this.currentService
      .voiceMessagesUpdateVoiceMessageGroup({
        body: this.model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  onSubmit() {
    try {
      if (this.loading) return;
      if (!this.isValidForm(this.form, this.tagName)) return;

      try {
        this.updateVoiceMessageGroupApi();
      } catch (error) {
        ConsoleService.error('error', error);
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.voiceMessages
      );
    }
  }
}
